import React, { Component } from 'react';
import {observer} from 'mobx-react'
import styles from './index.css';
import fonts from '../../../../iconfonts.css';
import SimpleLineIcon from 'react-simple-line-icons';
import {presets} from '../../../stores/index';

@observer
export default class ChooseCropPlan extends Component {
  render() {

      let cultureTotal = presets.culturePlan.wheat + presets.culturePlan.rape + presets.culturePlan.soy + presets.culturePlan.sunflower + presets.culturePlan.corn;
    let totalWeight = presets.storageEquip.reduce((sum,current)=>(sum+(+current.capacity*current.quantity)),0);
    let turnover = (cultureTotal / totalWeight).toFixed(1);
    if (!cultureTotal || !totalWeight) turnover = 0
      return (
        <div className={styles.chooseCropPlan}>
          <h3>План об'ємів культур</h3>
          <div className={styles.cropPlanCultures}>
            <CultureStats culture="wheat" title="Пшениця" />
            <CultureStats culture="rape" title="Ріпак"/>
            <CultureStats culture="soy" title="Соя"/>
            <CultureStats culture="sunflower" title="Соняшник"/>
            <CultureStats culture="corn" title="Кукурудза"/>
          </div>
            <h3>План зберігання культур</h3>
            <div className={styles.cropPlanCultures}>
                <Save culture="wheat" title="Пшениця" />
                <Save culture="rape" title="Ріпак"/>
                <Save culture="soy" title="Соя"/>
                <Save culture="sunflower" title="Соняшник"/>
                <Save culture="corn" title="Кукурудза"/>
            </div>

          {/*<div className={styles.culturesTable}>*/}
            {/*<div className={styles.dailyTurnover} style={{bottom:turnoverHeight}}>{dailyTurnover} тонн/день</div>*/}
            {/*<Month name="Июль" month={0} culturePlan={presets.culturePlan} cultureSpread={cultureSpread}/>*/}
            {/*<Month name="Август" month={1} culturePlan={presets.culturePlan} cultureSpread={cultureSpread}/>*/}
            {/*<Month name="Сентябрь" month={2} culturePlan={presets.culturePlan} cultureSpread={cultureSpread}/>*/}
            {/*<Month name="Октябрь" month={3} culturePlan={presets.culturePlan} cultureSpread={cultureSpread}/>*/}
            {/*<Month name="Ноябрь" month={4} culturePlan={presets.culturePlan} cultureSpread={cultureSpread}/>*/}
          {/*</div>*/}
          <div className={styles.result}>
            <p>Всього заплановано:</p>
            <h2>{cultureTotal} т.</h2>
            <p>Кількість обертів:</p>
            <h2>{turnover}</h2>
          </div>
        </div>
      );
    }
}

@observer
class CultureStats extends Component{
    state = {inputValue:presets.culturePlan[this.props.culture],interval:''};
    render() {
        let cultureTotal = presets.culturePlan.wheat + presets.culturePlan.rape + presets.culturePlan.soy + presets.culturePlan.sunflower + presets.culturePlan.corn;
        return (
            <div className={styles.cropPlanCulture}>
                <div className={styles.cultureCircle + ' ' + styles[this.props.culture]}><i className={fonts[this.props.culture]}/>
                </div>
                <h4>{this.props.title}</h4>
                <div className={styles.cropPlanAdjust}>
                    <div className={styles.quantityDecrease}
                         onMouseDown={()=>{
                             let internalfunc = setInterval(()=>{if(+this.state.inputValue-60 >= 0){this.setState({inputValue:+this.state.inputValue-60});presets.culturePlan[this.props.culture]-=60;}},200);
                             this.setState({interval:internalfunc})
                         }}
                         onClick={()=>{if(+this.state.inputValue-60 >= 0){this.setState({inputValue:+this.state.inputValue-60});presets.culturePlan[this.props.culture]-=60;}}}
                         onMouseLeave={()=>clearInterval(this.state.interval)}
                         onMouseUp={()=>clearInterval(this.state.interval)}
                    >
                        <SimpleLineIcon name="arrow-left" style={{fontSize: '1.25rem'}}/>
                    </div>
                    <input className={styles.itemQuantity} value={Math.round(this.state.inputValue)}
                           onChange={(e)=>{
                               if(!(/\D+/g.test(e.target.value))){this.setState({inputValue:e.target.value})}
                               presets.culturePlan[this.props.culture]+=+e.target.value - presets.culturePlan[this.props.culture]
                           }}
                           onBlur={(e)=>{if(e.target.value === ''){this.setState({inputValue:0}); presets.culturePlan[this.props.culture] = 0}}}
                    />
                    <div className={styles.quantityIncrease}
                         onMouseDown={()=>{
                             let internalfunc = setInterval(()=>{this.setState({inputValue:+this.state.inputValue+60});presets.culturePlan[this.props.culture]+=60;},200);
                             this.setState({interval:internalfunc})
                         }}
                         onMouseLeave={()=>clearInterval(this.state.interval)}
                         onClick={()=>{this.setState({inputValue:+this.state.inputValue+60});presets.culturePlan[this.props.culture]+=60;}}
                         onMouseUp={()=>clearInterval(this.state.interval)}
                    ><SimpleLineIcon name="arrow-right" style={{fontSize: '1.25rem'}}/></div>
                </div>
                <p>{cultureTotal ? (presets.culturePlan[this.props.culture]/cultureTotal*100).toFixed(1) : '0.0'}%</p>
            </div>
        )
    }
}

@observer
class Save extends Component{
    state = {inputValue:presets.cultureHoldingPlan[this.props.culture],interval:''};
    render() {
        let cultureTotal = presets.culturePlan.wheat + presets.culturePlan.rape + presets.culturePlan.soy + presets.culturePlan.sunflower + presets.culturePlan.corn;
        return (
            <div className={styles.cropPlanCulture} style={{border:'none'}}>
                <h4>{this.props.title}</h4>
                <div className={styles.cropPlanAdjust}>
                    <div className={styles.quantityDecrease}
                         onMouseDown={()=>{
                             let internalfunc = setInterval(()=>{if(+this.state.inputValue-1 >= 0){this.setState({inputValue:+this.state.inputValue-1});presets.cultureHoldingPlan[this.props.culture]-=1;}},200);
                             this.setState({interval:internalfunc})
                         }}
                         onClick={()=>{if(+this.state.inputValue-1 >= 0){this.setState({inputValue:+this.state.inputValue-1});presets.cultureHoldingPlan[this.props.culture]-=1;}}}
                         onMouseLeave={()=>clearInterval(this.state.interval)}
                         onMouseUp={()=>clearInterval(this.state.interval)}
                    >
                        <SimpleLineIcon name="arrow-left" style={{fontSize: '1.25rem'}}/>
                    </div>
                    <input className={styles.itemQuantity} value={Math.round(this.state.inputValue)}
                           onChange={(e)=>{
                               if(!(/\D+/g.test(e.target.value)) && e.target.value <=100) {
                                   this.setState({inputValue: e.target.value})
                                   presets.cultureHoldingPlan[this.props.culture] += +e.target.value - presets.cultureHoldingPlan[this.props.culture]
                               }
                           }}
                           onBlur={(e)=>{if(e.target.value === ''){this.setState({inputValue:0}); presets.culturePlan[this.props.culture] = 0}}}
                    />
                    <div className={styles.quantityIncrease}
                         onMouseDown={()=>{
                             let internalfunc = setInterval(()=>{if(+this.state.inputValue+1 <= 100){this.setState({inputValue:+this.state.inputValue+1});presets.cultureHoldingPlan[this.props.culture]+=1;}},200);
                             this.setState({interval:internalfunc})
                         }}
                         onClick={()=>{if(+this.state.inputValue+1 <= 100){this.setState({inputValue:+this.state.inputValue+1});presets.cultureHoldingPlan[this.props.culture]+=1;}}}
                         onMouseLeave={()=>clearInterval(this.state.interval)}
                         onMouseUp={()=>clearInterval(this.state.interval)}
                    ><SimpleLineIcon name="arrow-right" style={{fontSize: '1.25rem'}}/></div>
                </div>
                <p>Дн.</p>
            </div>
        )
    }
}



// @observer
// class Month extends Component{
//
//   render() {
//       let height = (
//           ( presets.culturePlan.wheat * this.props.cultureSpread.wheat[this.props.month]
//           + presets.culturePlan.rape * this.props.cultureSpread.rape[this.props.month]
//           + presets.culturePlan.soy * this.props.cultureSpread.soy[this.props.month]
//           + presets.culturePlan.sunflower * this.props.cultureSpread.sunflower[this.props.month]
//           + presets.culturePlan.corn * this.props.cultureSpread.corn[this.props.month] ) / 30 / 15
//           + 12).toFixed(0) + 'px';
//       return (
//           <div className={styles.month}>
//             <div className={styles.monthCultures} style={{height: height}}>
//               <Culture culture="wheat" quantity={presets.culturePlan.wheat * this.props.cultureSpread.wheat[this.props.month]}/>
//               <Culture culture="rape" quantity={presets.culturePlan.rape * this.props.cultureSpread.rape[this.props.month]}/>
//               <Culture culture="soy" quantity={presets.culturePlan.soy * this.props.cultureSpread.soy[this.props.month]}/>
//               <Culture culture="sunflower"
//                        quantity={presets.culturePlan.sunflower * this.props.cultureSpread.sunflower[this.props.month]}/>
//               <Culture culture="corn" quantity={presets.culturePlan.corn * this.props.cultureSpread.corn[this.props.month]}/>
//             </div>
//             <p>{this.props.name}</p>
//           </div>
//       )
//   }
// }
//
// const Culture = (props) => {
//   let height = (props.quantity/30/15).toFixed(0) + 'px';
//     return(
//       <div
//         className={styles.culture + " " + styles[props.culture]}
//         style={{height:height}}
//       />
//     )
// }


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/ChooseCropPlan/index.js